import React, {lazy, Suspense} from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './index.css';
import * as serviceWorker from './serviceWorker';
import {Switch, Route, BrowserRouter, HashRouter} from 'react-router-dom'

// import i18n (needs to be bundled ;))
import './i18n';

const App = lazy(() => import('./App'))

ReactDOM.render(
    <div className="container">
        <BrowserRouter>
            <Suspense fallback={""}>
                <Switch>
                    <Route path={"/"} component={App}/>
                </Switch>
            </Suspense>
        </BrowserRouter>
    </div>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
